import React from "react";
import { ModalLoadingSpinner } from "./modal-loading-spinner";
import { SwarovskiPageDataFrontend } from "@swo/storefront";
import { PublicConfigurationT } from "@swo/shared";
import { CartAspect } from "../global/cart-context/cart-aspect";
import { LoadedStorefrontPages } from "./LoadedStorefrontPages";

export const LoadedStorefrontPage: React.FC<{
  pageData: SwarovskiPageDataFrontend;
  recoverCartId: string | null;
  mode: "preview" | "published";
  intercom: PublicConfigurationT["integrations"]["intercom"];
  showLoadingIndicator: boolean;
  withDebugStyles?: boolean;
  config: PublicConfigurationT;
}> = ({ pageData, recoverCartId, intercom, mode, showLoadingIndicator, withDebugStyles, config }) => {
  return (
    <CartAspect localeSegmentCtx={pageData} recoverCartId={recoverCartId}>
      <LoadedStorefrontPages
        pageData={pageData}
        mode={mode}
        intercom={intercom}
        withDebugStyles={withDebugStyles}
        config={config}
      >
        {showLoadingIndicator && <ModalLoadingSpinner />}
      </LoadedStorefrontPages>
    </CartAspect>
  );
};
